import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=20daa208&scoped=true"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20daa208",
  null
  
)

export default component.exports